import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "../utils";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

/**
 * Bayi rol grubu — kullanıcı uçları. Şimdilik Son İşlemler (#412):
 * bayi kullanıcısının KENDİ işlemleri. Sözleşme: Workspace
 * docs/api-contracts/user-activity.md v1.1
 */
const dealerUsersApi = createApi({
  reducerPath: "dealerUsers",
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  keepUnusedDataFor: 60,
  endpoints(builder) {
    return {
      getDealerRolesMyActivity: builder.query({
        query: (data) => apiFunction(data, "/api/users/dealerRoles/getMyActivity", "POST"),
        keepUnusedDataFor: 0,
      }),
      getDealerRolesMyActivityDetail: builder.query({
        query: (data) => apiFunction(data, "/api/users/dealerRoles/getMyActivityDetail", "POST"),
      }),
    };
  },
});

export const {
  useLazyGetDealerRolesMyActivityQuery,
  useGetDealerRolesMyActivityDetailQuery,
} = dealerUsersApi;
export { dealerUsersApi };
